<template>
  <div>
    <datatable
      title="Admin Owners Schedule"
      @delete="deleteOwnerSchedule"
      @create="createOwnerSchedule"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-languages',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'owner',
          value: 'owner'
        },
        {
          name: 'group_name',
          value: 'group_name'
        },
        {
          name: 'timing',
          value: 'timing'
        },
        {
          name: 'week_day',
          value: 'week_day'
        }
      ],
      data: [],
      operations: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    deleteOwnerSchedule (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.owner + ' - ' + delete_data.group_name + ' - ' + delete_data.timing + ' - ' + delete_data.week_day,
        item_name: delete_data.name,
        method: 'deleteOwnerSchedule',
        method_params: { id: delete_data.id }
      })
    },
    createOwnerSchedule () {
      this.create({ designator: 'admin-owner-schedule-form', component_name: 'AdminOwnerScheduleForm', is_create: true, modal_title: 'Create new Owner Schedule' })
    },
    init () {
      this.$network_utils.getOwnersSchedule().then(response => {
        this.data = response
      })
    },
    editClick (data) {
      this.create({ designator: 'admin-owner-schedule-form', component_name: 'AdminOwnerScheduleForm', data, modal_title: 'Owner Schedule' })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
